import React from "react";
import { ContextMenu, ContextMenuItem } from "src/components/ContextMenu";
import { PropsType } from "./types";
import { useChangesContextMenu } from "./useChangesContextMenu";

export const ChangesContextMenu: React.FC<PropsType> = (props) => {
  const { handleOnClickView, handleOnClickDelete, showDeleteDraftEntrance } =
    useChangesContextMenu(props);

  return (
    <ContextMenu consumerAnchorEl={props.consumerAnchorEl}>
      <ContextMenuItem onHandleClick={handleOnClickView}>View</ContextMenuItem>
      {showDeleteDraftEntrance && (
        <ContextMenuItem onHandleClick={handleOnClickDelete}>
          Delete...
        </ContextMenuItem>
      )}
    </ContextMenu>
  );
};
